import React from "react";
import { Link } from "react-router-dom";
import tw from "tailwind-styled-components";

import Button from "../components/Button";

const Heading = tw.h1`
text-2xl
leading-6 
text-gray-900
mt-5
`;

const Content = tw.p`
my-4
text-lg
`;

const HomeWrapper = tw.div`
mt-20 
text-center 
max-w-2xl
mx-auto
`;

export default function Home() {
  return (
    <HomeWrapper>
      <Heading>What is Humans (beta)</Heading>
      <Content>
        Humans is a minimalist personal CRM for the people you meet.
      </Content>
      <Content>
        We are still actively developing the first version of Humans, but if you
        would like to come in and have a look around, we'd love to hear your
        feedback.
      </Content>
      <Heading>Get Started</Heading>
      <div className="mt-5">
        <Link to="/sign-up">
          <Button>Register</Button>
        </Link>
        &nbsp; or &nbsp;
        <Link to="/sign-in">
          <Button>Sign in</Button>
        </Link>
      </div>
    </HomeWrapper>
  );
}
